import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardImg,
  Col,
  Container,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import BreadCrumb from "../../../Components/Common/BreadCrumb.js";
import DestinationService from "../../../services/KangarooServices/DestinationService.js";
import DeleteModal from "../../../Components/Common/DeleteModal.js";
import { imageBaseApi } from "../../../utilis/imageHelper.js";

const Destination = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(9);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchPage = async () => {
    setIsLoading(true);
    try {
      const response = await DestinationService.getList();
      setData(response);
      setTotalRows(response.length);
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch destinations");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPage();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await DestinationService.deleteDestination(selectedDeleteItem.id);
        fetchPage();
        toast.success("Destination deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete destination"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const filteredDestinations = data.filter((destination) => {
    const term = searchTerm.toLowerCase();
    return (
      destination.name.toLowerCase().includes(term) ||
      destination.description?.toLowerCase().includes(term) ||
      destination.studyBenefits?.toLowerCase().includes(term) ||
      destination.visaRequirements?.toLowerCase().includes(term)
    );
  });

  const totalPages = Math.ceil(filteredDestinations.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = filteredDestinations.slice(
    startIndex,
    startIndex + pageSize
  );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Destinations" pageTitle="Content Management" />

        <Row className="mb-4">
          <Col md={6} xs={12}>
            <Button
              className="btn btn-success"
              onClick={() => navigate("/destination-countries/create")}
            >
              + Create Destination
            </Button>
          </Col>
          <Col md={6} xs={12}>
            <div className="d-md-flex justify-content-end">
              <div className="search-box flex-shrink-0">
                <Input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  placeholder="Search destinations..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="ri-search-line search-icon"></i>
              </div>
            </div>
          </Col>
        </Row>

        {isLoading ? (
          <div className="my-5 d-flex justify-content-center align-items-center">
            <Triangle visible height="80" width="80" color="#405189" />
          </div>
        ) : (
          <>
            <Row>
              {paginatedData?.map((item) => (
                <Col sm={6} xl={4} key={item.id} className="mb-4">
                  <Card className="border-0 shadow-sm h-100 d-flex flex-column hover-lift transition">
                    <div
                      className="position-relative"
                      style={{ aspectRatio: "16/9", overflow: "hidden" }}
                    >
                      <CardImg
                        src={`${imageBaseApi}${item?.flagMedia?.url}`}
                        loading="lazy"
                        style={{ objectFit: "contain" }}
                        className="card-img-top w-100 h-100"
                      />
                      <Badge
                        color={item.isActive ? "success" : "secondary"}
                        className="position-absolute top-0 end-0 m-2 px-3 py-2 rounded-pill shadow-sm"
                      >
                        {item.isActive ? "Active" : "Inactive"}
                      </Badge>
                    </div>
                    {/* <CardHeader className="bg-transparent border-bottom">
                     
                    </CardHeader> */}

                    <CardBody className="">
                      <small className="text-muted mb-3">
                        {item.slug || "-"}
                      </small>

                      <h5 className=" fw-semibold text-dark">{item.name}</h5>

                      {/* <p
                        className="text-muted mb-3"
                        style={{ fontSize: "14px", lineHeight: "1.6" }}
                      >
                        {item.description &&
                          item.description.split(" ").slice(0, 20).join(" ")}
                        {item.description &&
                        item.description.split(" ").length > 20
                          ? "..."
                          : ""}
                      </p> */}
                      <div
                        className=" small "
                        style={{ overflow: "hidden" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            item.description?.length > 300
                              ? item.description.slice(0, 300) + "..."
                              : item.description,
                        }}
                      />
                      {/* <div className="mb-2">
                        {item.studyBenefits && (
                          <div className="mb-2 d-flex align-items-start">
                            <i className="ri-graduation-cap-line text-primary me-2 mt-1"></i>
                            <span className="small">
                              <strong>Study Benefits:</strong>{" "}
                              {item.studyBenefits}
                            </span>
                          </div>
                        )}

                        {item.visaRequirements && (
                          <div className="mb-2 d-flex align-items-start">
                            <i className="ri-passport-line text-primary me-2 mt-1"></i>
                            <span className="small">
                              <strong>Visa:</strong> {item.visaRequirements}
                            </span>
                          </div>
                        )}

                        {item.costOfLiving && (
                          <div className="mb-2 d-flex align-items-start">
                            <i className="ri-money-dollar-circle-line text-success me-2 mt-1"></i>
                            <span className="small">
                              <strong>Cost of Living:</strong>
                              <span className="text-success fw-semibold ms-1">
                                Rs. {item.costOfLiving}
                              </span>
                            </span>
                          </div>
                        )}

                        {item.partTimeWork && (
                          <div className="mb-2 d-flex align-items-start">
                            <i className="ri-briefcase-line text-info me-2 mt-1"></i>
                            <span className="small">
                              <strong>Part-time Work:</strong>{" "}
                              {item.partTimeWork}
                            </span>
                          </div>
                        )}

                        {item.postStudyWork && (
                          <div className="mb-2 d-flex align-items-start">
                            <i className="ri-user-star-line text-warning me-2 mt-1"></i>
                            <span className="small">
                              <strong>Post-study Work:</strong>{" "}
                              {item.postStudyWork}
                            </span>
                          </div>
                        )}
                      </div> */}
                    </CardBody>

                    <div className="card-footer bg-transparent d-flex justify-content-between align-items-center gap-2 border-top">
                      <Link
                        to={`/destination-countries/detail/${item.slug}`}
                        className="text-decoration-none link-secondary fw-semibold d-flex align-items-center"
                      >
                        View Details
                        <i className="ri-arrow-right-s-line ms-1"></i>
                      </Link>
                      <div className="d-flex gap-2 justify-content-center align-content-center align-items-center">
                        <Button
                          color="btn btn-soft-warning"
                          className="btn-sm"
                          size="sm"
                          onClick={() =>
                            navigate(`/destination-countries/update/${item.slug}`)
                          }
                        >
                          <i className="ri-edit-line" />
                        </Button>

                        <Button
                          className="btn btn-soft-danger btn-sm"
                          color="danger"
                          size="sm"
                          onClick={() => handleDeleteClick(item)}
                        >
                          <i className="ri-delete-bin-5-line" />
                        </Button>
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>

            {filteredDestinations.length === 0 && (
              <div className="text-center py-5">
                <i className="ri-search-line display-4 text-muted"></i>
                <p className="text-muted mt-3">No destinations found</p>
              </div>
            )}

            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center mt-4">
                <Pagination className="justify-content-center">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                  </PaginationItem>

                  {[...Array(totalPages)].map((_, index) => (
                    <PaginationItem
                      key={index}
                      active={currentPage === index + 1}
                    >
                      <PaginationLink
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}

                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      next
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              </div>
            )}
          </>
        )}
      </Container>

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </div>
  );
};

export default Destination;
